import Axios from '@/api/http'
/**
 * 用户编辑里面的彻底删除用户
 * */
export function adsolutedeleteuser(date) {
  return Axios({
    method: 'post',
    url: '/api/adsolutedeleteuser',
    data: date,
    
  })
}

/**
 * 解除微信绑定
 * */
export function unbindopenid(date) {
  return Axios({
    method: 'post',
    url: '/api/unbindopenid',
    data: date
  })
}

/**
 * 获取用户标签列表
 * */
export function getusertiplist(date) {
  return Axios({
    method: 'post',
    url: '/openapi/getusertiplist',
    data: date
  })
}

/**
 * 获取用户标签列表
 * */
export function getnoopenusertiplist(date) {
  return Axios({
    method: 'post',
    url: '/api/getusertiplist',
    data: date
  })
}

/**
 * 获取标签列表
 * */
export function getdepttiplist(date) {
  return Axios({
    method: 'post',
    url: '/openapi/getdepttiplist',
    data: date
  })
}

/**
 * 下载用户模板
 * */
export function getusertemplate(date) {
  return Axios({
    method: 'post',
    url: '/api/getusertemplate',
    data: date,
    responseType: "arraybuffer"
  })
}

/**
 * 下载部门模板
 * */
export function getorgtemplate(date) {
  return Axios({
    method: 'post',
    url: '/api/getorgtemplate',
    data: date
  })
}

/**
 * 下载部门模板（22-2-22换）
 * */
export function exportorgname(date) {
  return Axios({
    method: 'post',
    url: '/api/exportorgname',
    data: date,
    // responseType: "arraybuffer"
  })
}

/**
 * 
 * */
export function deleteorganization(date) {
  return Axios({
    method: 'post',
    url: '/api/deleteorganization',
    data: date,
  })
}

export function validatedept(date) {
  return Axios({
    method: 'post',
    url: '/api/validatedept',
    data: date,
  })
}

export function validadmin(date) {
  return Axios({
    method: 'post',
    url: '/api/validadmin',
    data: date,
  })
}

export function addbatchorg(date) {
  return Axios({
    method: 'post',
    url: '/api/addbatchorg',
    data: date,
  })
}

export function batchaddadmintor(date) {
  return Axios({
    method: 'post',
    url: '/api/batchaddadmintor',
    data: date,
  })
}
export function getchildorg(date) {
  return Axios({
    method: 'post',
    url: '/api/getchildorg',
    data: date,
  })
}

